import AddPointForm from './addPointForm.container'

export default AddPointForm